import { WebNotificationMessageService } from './web';
export default WebNotificationMessageService;
